import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "containers/Template/Navbar/Navbar";
import Header from "containers/Template/Header/Header";
import Footer from "containers/Template/Footer/Footer";
import BaseRouter from "routes";
import UnregisterBannerImage from "components/Account/Register/UnregisterBannerImage";
import OnboardingBannerImage from "components/Account/Onboarding/OnboardingBannerImage";

import { connect } from "react-redux";

class Katamundi_App extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<Router>
				{this.props.type === "LOGIN_SUCCESS" ? (
					<div className="App">
						<div className="content-wrapper">
							<Header />
							<Navbar />
							<BaseRouter userState="registered" appState={this.state} />
						</div>
						<Footer />
					</div>
				) : this.props.type === "REGISTER_SUCCESS" ? (
					<div className="App">
						<div className="content-wrapper">
							<OnboardingBannerImage />
							<BaseRouter userState="onboarding" appState={this.state} />
						</div>
						<Footer />
					</div>
				) : (
					<div className="App">
						<div className="content-wrapper">
							<UnregisterBannerImage />
							<BaseRouter userState="unregistered" appState={this.state} />
						</div>
						<Footer />
					</div>
				)}
			</Router>
		);
	}
}

function mapStateToProps(state) {
	return {
		type: state.type,
	};
}

export default connect(mapStateToProps)(Katamundi_App);
